export class Report {
    public report: ReportElement[];

    constructor(data: any) {
        this.report = data.map((reportElement: ReportElement) => {
            return new ReportElement(reportElement.id, reportElement.type, reportElement.params);
        });
    }
}

export class ReportElement {
    public id: number;
    public type: string;
    public params: ReportElementData;

    constructor(id: number, type: string, params: ReportElementData) {
        this.id = id;
        this.type = type;
        this.params = new ReportElementData(params);
    }
}

export class ReportElementDataScore {
    public points: number;
    public pointsMax: number;
    public score: number;

    constructor(data: any) {
        this.points = parseInt(data.points, 10);
        this.pointsMax = parseInt(data.points_max, 10);
        this.score = parseInt(data.score, 10);
    }
}

export class ReportElementData {
    public body: string | undefined;
    public label: string | undefined;
    public description: string | undefined;
    public color: string | undefined;
    public url: string | undefined;
    public score: ReportElementDataScore | undefined;

    constructor(params: any) {
        this.score = params.score ? new ReportElementDataScore(params.score) : undefined;
        this.body = params.body ? params.body : undefined;
        this.label = params.label ? params.label : undefined;
        this.description = params.description ? params.description : undefined;
        this.color = params.color ? params.color : undefined;
        this.url = params.url ? params.url : undefined;
    }
}
